module.exports = __webpack_public_path__ + "img/GAME_CATCHTHEMOLE.35c186dd.png";